import { render, staticRenderFns } from "./ProductInShopTable.vue?vue&type=template&id=22c60de8&scoped=true&"
import script from "./ProductInShopTable.vue?vue&type=script&lang=js&"
export * from "./ProductInShopTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductInShopTable.vue?vue&type=style&index=0&id=22c60de8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c60de8",
  null
  
)

export default component.exports